import { useQuery, UseQueryOptions } from 'react-query';

import { useService } from '@core/inversify-react';

import { GetBranchInspectionByIdRepoType, IGetBranchInspectionByIdRepo } from '../repos';
import { IBranchInspection } from '../interfaces';

export const useBranchInspectionById = (id?: string, options?: UseQueryOptions<IBranchInspection, Error, IBranchInspection, string[]>) => {
  const getBranchInspectionByIdRepo = useService<IGetBranchInspectionByIdRepo>(GetBranchInspectionByIdRepoType);

  return useQuery<IBranchInspection, Error, IBranchInspection, string[]>(
    ['branch-inspections', id || ''],
    async ({ queryKey }) => {
      const [, id] = queryKey;

      if (!id) {
        throw new Error('No inspection ID provided');
      }

      const result = await getBranchInspectionByIdRepo.execute(id);

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    {
      ...options,
      enabled: !!id,
    },
  );
};
